import { render, staticRenderFns } from "./PrintRepairBill.vue?vue&type=template&id=36dc4180&scoped=true"
import script from "./PrintRepairBill.vue?vue&type=script&lang=js"
export * from "./PrintRepairBill.vue?vue&type=script&lang=js"
import style0 from "./PrintRepairBill.vue?vue&type=style&index=0&id=36dc4180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dc4180",
  null
  
)

export default component.exports